import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { BeatYourBrokerHelper } from './apg-beat-your-broker-helper';

@Injectable()
export class BeatYourBrokerGuard {

    constructor(
        private helper: BeatYourBrokerHelper,
        private router: Router) {
    }

    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        const { page } = route.params;
        if (!page)
            return true;
        if (this.helper.allowedPages.includes(parseInt(page)))
            return true;

        const lastPage = this.helper.allowedPages.length ? this.helper.allowedPages[this.helper.allowedPages.length - 1] : 0;
        this.router.navigate(['/coverchecker', lastPage])
        return false;
    }
}